var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.fragmentContent)?_c(_vm.fragmentContent.renderTag,{tag:"component",attrs:{"content":_vm.fragmentContent}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }